import * as React from 'react'
import { Backdrop, Container, styled } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'

const LoadingContainer = styled(Container)(
  () => `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
  `
)

const Typography = styled(MIUTypography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontSize: '1.2em',
  color: theme.palette.text.white,
  fontWeight: 700,
  paddingBottom: 6,
  paddingTop: 6,
}))

const LoaderContainer = ({ conditions }) => (
  <Backdrop
    sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}
    open={conditions.some(Boolean)}>
    <LoadingContainer>
      <Box width="100%" display="flex" flexDirection="column" justifyContent="center">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress color="secondary" />
          </Box>
        </Box>
        <Typography>Procesando solicitud...</Typography>
      </Box>
    </LoadingContainer>
  </Backdrop>
)

export default LoaderContainer
